'use client';

import React, {createContext, useContext, ReactNode} from 'react';
import {AssetVideo} from '@/generated/graphql';

export interface VideoPlayerContextData {
    /** Asset data - could be from a previewable lecture or a static video asset like the coding exercises promo video */
    asset?: AssetVideo;
    /** Duration of the video in seconds */
    durationInSeconds: number;
}

const VideoPlayerContext = createContext<VideoPlayerContextData | null>(null);

interface VideoPlayerProviderProps {
    children: ReactNode;
    asset?: AssetVideo;
    durationInSeconds: number;
}

/**
 * Provider that provides video player context with asset data
 */
export function VideoPlayerProvider({
    children,
    asset,
    durationInSeconds,
}: VideoPlayerProviderProps) {
    const contextValue: VideoPlayerContextData = {
        asset,
        durationInSeconds,
    };

    return (
        <VideoPlayerContext.Provider value={contextValue}>{children}</VideoPlayerContext.Provider>
    );
}

/**
 * Hook to access video player context data
 */
export function useVideoPlayerContext(): VideoPlayerContextData {
    const context = useContext(VideoPlayerContext);
    if (!context) {
        throw new Error('useVideoPlayerContext must be used within a VideoPlayerProvider');
    }
    return context;
}
